// FieldIQ — Web-push subscribe/unsubscribe/preferences

import { FIELDIQ_API_URL, getToken } from "./api";

function _urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return new Uint8Array([...raw].map((c) => c.charCodeAt(0)));
}

async function _getVapidPublicKey() {
  try {
    const res = await fetch(`${FIELDIQ_API_URL}/push/vapid-public-key`);
    if (!res.ok) return null;
    const { publicKey } = await res.json();
    return publicKey;
  } catch {
    return null;
  }
}

export async function pushSubscribe(userId) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window))
    return null;
  try {
    const publicKey = await _getVapidPublicKey();
    if (!publicKey) return null;
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: _urlBase64ToUint8Array(publicKey),
    });
    const tok = getToken();
    await fetch(`${FIELDIQ_API_URL}/push/subscribe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tok}`,
      },
      body: JSON.stringify({ subscription: sub.toJSON() }),
    });
    return sub;
  } catch {
    return null;
  }
}

export async function pushUnsubscribe() {
  if (!("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    const tok = getToken();
    await fetch(`${FIELDIQ_API_URL}/push/subscribe`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tok}`,
      },
      body: JSON.stringify({ endpoint: sub.endpoint }),
    });
    await sub.unsubscribe();
  } catch {}
}

export async function pushUpdatePrefs(prefs) {
  if (!("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    const tok = getToken();
    await fetch(`${FIELDIQ_API_URL}/push/subscribe/prefs`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tok}`,
      },
      body: JSON.stringify({ endpoint: sub.endpoint, prefs }),
    });
  } catch {}
}
